// extracted by mini-css-extract-plugin
export default {"QuizCategoryModal":"quizCategoryModal_QuizCategoryModal__hn5Kb","fadeIn":"quizCategoryModal_fadeIn__G4JUM","button":"quizCategoryModal_button__lffdc"};